window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.admissionsInfoBox = window.locales.am.admissionsInfoBox || {};window.locales.am.admissionsInfoBox = {...window.locales.am.admissionsInfoBox, ...{
    "heading": "የመግቢያ ጥያቄ?",
    "content": "በ {admissionsEmailLink} ኢሜይል ያድርጉልን ወይም {scheduleVideoChatLink} ን ከቡድናችን አባል ጋር ቀጠሮ ይያዙ።",
    "1_1_video_chat": "1፡1 የቪዲዮ ውይይት",
    "contactUs": "ያግኙን"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.admissionsInfoBox = window.locales.ar.admissionsInfoBox || {};window.locales.ar.admissionsInfoBox = {...window.locales.ar.admissionsInfoBox, ...{
    "heading": "سؤال القبول؟",
    "content": "يمكنك مراسلتنا عبر البريد الإلكتروني على {admissionsEmailLink} أو جدولة {scheduleVideoChatLink} مع أحد أعضاء فريقنا.",
    "1_1_video_chat": "محادثة فيديو 1:1",
    "contactUs": "اتصل بنا"
}
};window.locales.en = window.locales.en || {};window.locales.en.admissionsInfoBox = window.locales.en.admissionsInfoBox || {};window.locales.en.admissionsInfoBox = {...window.locales.en.admissionsInfoBox, ...{
    "heading": "Admissions Question?",
    "content": "Email us at {admissionsEmailLink} or schedule a {scheduleVideoChatLink} with a member of our team.",
    "1_1_video_chat": "1:1 video chat",
    "contactUs": "Contact Us"
}
};window.locales.es = window.locales.es || {};window.locales.es.admissionsInfoBox = window.locales.es.admissionsInfoBox || {};window.locales.es.admissionsInfoBox = {...window.locales.es.admissionsInfoBox, ...{
    "heading": "¿Preguntas sobre admisiones?",
    "content": "Envíenos un correo electrónico a {admissionsEmailLink} o programe un {scheduleVideoChatLink} con un miembro de nuestro equipo.",
    "1_1_video_chat": "Chat de video 1:1",
    "contactUs": "Contáctenos"
}
};window.locales.it = window.locales.it || {};window.locales.it.admissionsInfoBox = window.locales.it.admissionsInfoBox || {};window.locales.it.admissionsInfoBox = {...window.locales.it.admissionsInfoBox, ...{
    "heading": "Domande sull'ammissione?",
    "content": "Inviaci un'e-mail all'indirizzo {admissionsEmailLink} o programma una {scheduleVideoChatLink} con un membro del nostro team.",
    "1_1_video_chat": "Video chat 1:1",
    "contactUs": "Contattaci"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.admissionsInfoBox = window.locales.zh.admissionsInfoBox || {};window.locales.zh.admissionsInfoBox = {...window.locales.zh.admissionsInfoBox, ...{
    "heading": "入学问题？",
    "content": "请发送电子邮件至{admissionsEmailLink}或与我们团队的成员安排{scheduleVideoChatLink} 。",
    "1_1_video_chat": "1对1视频聊天",
    "contactUs": "联系我们"
}
};